import type { EChartsType } from 'echarts/core';

import { interactionConfig } from '../../config/interaction';

type TooltipSize = {
  contentSize: [number, number];
};

function computeAxisPosition(
  pointerPos: number,
  tooltipSize: number,
  containerOffset: number,
  viewportSize: number
): number {
  const { tooltipOffset, viewportMargin } = interactionConfig;
  const wouldOverflow = containerOffset + pointerPos + tooltipOffset + tooltipSize > viewportSize - viewportMargin;

  return wouldOverflow ? pointerPos - tooltipSize - tooltipOffset : pointerPos + tooltipOffset;
}

export function createCursorTooltipPosition(chart: EChartsType, pointerX: number, pointerY: number) {
  return (_point: unknown, _params: unknown, _dom: unknown, _rect: unknown, size: TooltipSize): [number, number] => {
    const [tooltipWidth, tooltipHeight] = size.contentSize;
    const chartRect = chart.getDom().getBoundingClientRect();

    const x = computeAxisPosition(pointerX, tooltipWidth, chartRect.left, window.innerWidth);
    const y = computeAxisPosition(pointerY, tooltipHeight, chartRect.top, window.innerHeight);

    return [x, y];
  };
}
